import React, { Fragment, useState, useContext, useEffect } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';

const NuevoProyecto = () => {

    // Obtener el state del formulario
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, formulario, formularioeditar, errorformulario, mostrarFormulario, obtenerUltimosCambios, guardarUltimoCambio, agregarProyecto, mostrarError, proyectoActual, actualizarProyecto } = proyectosContext;

    // State para Proyecto
    const [ proyectostate, guardarProyecto ] = useState({
        nombre: ''
    });

    
    // Extraer nombre de proyecto
    const { nombre } = proyectostate;

    // Effect para guardar el proyecto en el state
    useEffect(() => {
        if(formularioeditar && proyecto !== null){
            // Extraer el nombre del proyecto actual
            const [ proyectoActual ] = proyecto;

            guardarProyecto(proyectoActual);
        }else {
            guardarProyecto({ nombre: '' });
        }
    }, [formularioeditar, proyecto]);
    
    // Lee los contenidos del input
    const onChangeProyecto = e => {
        guardarProyecto({
            ...proyectostate,
            [e.target.name] : e.target.value
        });
    }

    // Cuando el usuario crea un proyecto
    const onSubmitProyecto = e => {
        e.preventDefault();

        // Validar el proyecto
        if(nombre.trim() === '') {
            mostrarError();
            return;
        }

        if(!formularioeditar){
            // Agregar al state
            agregarProyecto(proyectostate);
        }else{
            // Actualiza el state
            actualizarProyecto(proyectostate);
            proyectoActual(proyectostate._id); // Pone en el state el proyecto actual
            guardarUltimoCambio(proyectostate._id, 'Proyecto', proyectostate.nombre, 'Actualizó el nombre');
            obtenerUltimosCambios(proyectostate._id); // Filtra los ultimos cambios
        }

        // Reiniciar el form
        guardarProyecto({
            nombre: ''
        })
    }

    return ( 
        <Fragment>
            {
                formulario ? (
                    <form
                        className="formulario-nuevo-proyecto"
                        onSubmit={onSubmitProyecto}
                    >
                        <div className="form-group">
                            <input
                                type="text"
                                id="nombre-proyecto"
                                className="form-control"
                                placeholder="Nombre Proyecto"
                                name="nombre"
                                value={nombre}
                                autoComplete="off"
                                onChange={onChangeProyecto}
                            />
                            <label className="form-label" htmlFor="nombre-proyecto">Nombre Proyecto</label>
                        </div>

                        <input 
                            type="submit"
                            className="btn btn-primario btn-block"
                            value={formularioeditar ? "Editar Proyecto" : "Agregar Proyecto"}
                        />
                    </form>
                ) : (
                    <button
                        type="button"
                        className="btn btn-block btn-primario"
                        onClick={() => mostrarFormulario()}
                    >Nuevo Proyecto</button>
                )
            }

            { errorformulario ? <p className="mensaje error">El nombre es obligatorio</p> : null}
        </Fragment>
    );
}
 
export default NuevoProyecto;